export const exampleFunction = (arg: number): string => {
    return `${arg}`;
};
